import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-utilitats',
  templateUrl: './utilitats.component.html'
})
export class UtilitatsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
